import React from "react";

import { IconContainer, MainContainer, TextContainer } from "./Containers";
import { Description } from "./Description";
import { Icon, IIconProps } from "./Icon";
import { INameValueProps, NameValue } from "./NameValue";

interface IAttributeProps extends INameValueProps, IIconProps {
  description?: string;
}

export const Attribute: React.FC<IAttributeProps> = ({
  iconCode,
  description,
  name,
  value,
  format,
  type
}) => (
  <MainContainer>
    <IconContainer>
      <Icon iconCode={iconCode} />
    </IconContainer>
    <TextContainer>
      <NameValue name={name} value={value} format={format} type={type} />
      {description && <Description>{description}</Description>}
    </TextContainer>
  </MainContainer>
);
